export default __webpack_public_path__ + "static/media/Phone-Activity-3x.a0dc4ab9.png";